import { useEffect } from 'react'
import { useFileUploadContext } from '../controller/UploadFileContext'

type Props = {
  slot: string
  defaultFileTagTitles?: string[]
}

/** Applies file tag titles to the upload context without rendering tag UI. */
export const AutoUploadFileTags = ({ slot, defaultFileTagTitles }: Props) => {
  const { updateFileTagTitles } = useFileUploadContext()

  useEffect(() => {
    if (!defaultFileTagTitles?.length) {
      return
    }
    updateFileTagTitles(slot, defaultFileTagTitles)
  }, [defaultFileTagTitles, slot, updateFileTagTitles])

  return null
}
